import axios from "../../../common/axiosInstance"

export const fetcher = async (url: string, params: object) => {
  const res = await axios.get(url, { params })
  return res.data
}
